var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLifeAndPeopleSchoolAndEducation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-2352.000000, -1040.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Life-and-people/School-and-education",
    transform: "translate(2352.000000, 1040.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28,21 L28,15.636 L30,14.886 L30,19 C30,19.942 29.667,21 28,21 L28,21 Z M16,20.121 L26,16.386 L26,21 C26,23 21,25 16,25 C11,25 6,23 6,21 L6,16.386 L16,20.121 Z M32,12 L16,18 L0,12 L16,7 L32,12 Z",
    id: 43
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLifeAndPeopleSchoolAndEducation);
export default __webpack_public_path__ + "static/media/life-and-people-school-and-education.8838afe8.svg";
export { ForwardRef as ReactComponent };